import gettext, { pgettext } from '@sdk/lang/gettext';

export function getConversationDeleteTexts() {
  const confirmationWarning = pgettext(
    'deleting conversation confirmation',
    'Warning: this cannot be undone'
  );

  const description = gettext('The conversation will be deleted with all its message history.');

  const deletingConfirmationLabel = pgettext(
    'deleting conversation confirmation',
    'I understand the consequences of this action'
  );

  return {
    confirmationWarning,
    deletingConfirmationLabel,
    description,
  };
}
